// Form Flow DOM Manipulation Fixes
// This script fixes issues with Select2 and radio button initialization

(function () {
    'use strict';

    // Wait for the page to be fully loaded before attempting fixes
    let initAttempts = 0;
    const maxAttempts = 50; // Increased to allow more time for deferred scripts

    function waitForDependencies(callback) {
        if (typeof jQuery !== 'undefined' && typeof jQuery.fn.select2 !== 'undefined') {
            callback();
        } else {
            initAttempts++;
            if (initAttempts < maxAttempts) {
                setTimeout(() => waitForDependencies(callback), 100);
            } else {
                // Silently fail if dependencies not available - this is expected on pages without Select2
            }
        }
    }

    function initializeFormElements() {
        const $ = jQuery;

        // Fix Select2 initialization for legacy multi-select fields
        function fixSelect2() {
            $('select[tg-connection-id][multiple]').each(function () {
                const $select = $(this);

                if ($select.data('select2')) {
                    $select.select2('destroy');
                }

                $select.select2({
                    placeholder: $select.attr('data-placeholder') || 'Select an option',
                    multiple: true,
                    width: '100%',
                    closeOnSelect: false,
                    allowClear: true
                });

                const selectedValues = $select.find('option:selected').map(function () {
                    return this.value;
                }).get();

                if (selectedValues.length > 0) {
                    $select.val(selectedValues).trigger('change.select2');
                }
            });
        }

        // Fix radio button styling
        function fixRadioButtons() {
            // Function to update radio button visual state
            function updateRadioVisual(radio) {
                const $radio = $(radio);
                const $label = $radio.closest('.w-radio');
                const $radioButton = $label.find('.radio-button');

                if (!$radioButton.length) return;

                // Get all radios in the same group
                const groupName = radio.name;
                $(`input[type="radio"][name="${groupName}"]`).each(function () {
                    const $groupLabel = $(this).closest('.w-radio');
                    const $groupButton = $groupLabel.find('.radio-button');
                    $groupButton.removeClass('checked');
                });

                // Add checked class to selected radio
                if (radio.checked) {
                    $radioButton.addClass('checked');
                }
            }

            // Initialize all radio buttons with their current state
            $('input[type="radio"]').each(function () {
                if (this.checked) {
                    updateRadioVisual(this);
                }
            });

            // Handle radio button changes
            $(document).off('change.radiofix').on('change.radiofix', 'input[type="radio"]', function () {
                updateRadioVisual(this);

                // Handle custom price field toggle
                if (this.name === 'listing[field_6qzwdgqtsuhne0oqrogg]' ||
                    this.name === 'field_6qzwdgqtsuhne0oqrogg') {
                    togglePriceField();
                }
            });
        }

        // Toggle price field visibility
        function togglePriceField() {
            const customPriceRadio = document.getElementById('Custom-price');
            const priceField = document.querySelector('input[data-animate-price-shadow="true"]') ||
                document.getElementById('field_exxh85wlep8bpbqiyzgmkg-2') ||
                document.getElementById('listing[field_exxh85wlep8bpbqiyzgmkg]') ||
                document.getElementById('field_exxh85wlep8bpbqiyzgmkg');

            if (customPriceRadio && priceField) {
                const shouldShow = customPriceRadio.checked;
                const shadowContainer = priceField.closest('.radio-btn-wpr.is-separated') || priceField;
                shadowContainer.style.display = shouldShow ? '' : 'none';
            }
        }

        function fixAnimateLegacyForm() {
            const categorySelect = document.querySelector('#select[tg-connection-id="field_j1n4ywekfhxgdwmmscw0gq"]');
            const categoryHidden = document.querySelector('#hidden[tg-connection-id="field_j1n4ywekfhxgdwmmscw0gq"]');
            const customPriceRadio = document.getElementById('Custom-price');
            const pricePrimary = document.querySelector('input[data-animate-price-primary="true"]') ||
                document.getElementById('listing[field_exxh85wlep8bpbqiyzgmkg]');
            const priceShadow = document.querySelector('input[data-animate-price-shadow="true"]') ||
                document.getElementById('field_exxh85wlep8bpbqiyzgmkg-2');

            if (!categorySelect && !categoryHidden && !pricePrimary && !priceShadow) {
                return;
            }

            function syncAnimateCategories() {
                if (!categorySelect || !categoryHidden) return;

                const selectedValues = Array.from(categorySelect.selectedOptions || [])
                    .map((option) => option.value)
                    .filter(Boolean);

                categoryHidden.value = selectedValues.join(',');
            }

            function syncAnimatePrice(source) {
                const sourceValue = source && source.value !== '' ? source.value : null;
                const fallbackValue = sourceValue !== null
                    ? sourceValue
                    : (priceShadow && priceShadow.value !== '' ? priceShadow.value : (pricePrimary ? pricePrimary.value : ''));

                if (pricePrimary && pricePrimary.value !== fallbackValue) {
                    pricePrimary.value = fallbackValue;
                }

                if (priceShadow && priceShadow.value !== fallbackValue) {
                    priceShadow.value = fallbackValue;
                }
            }

            function toggleAnimatePriceField() {
                if (!customPriceRadio || !priceShadow) return;

                const shouldShow = customPriceRadio.checked;
                const shadowContainer = priceShadow.closest('.radio-btn-wpr.is-separated') || priceShadow;
                shadowContainer.style.display = shouldShow ? '' : 'none';
            }

            if (categorySelect && categoryHidden) {
                syncAnimateCategories();
                $(categorySelect).off('change.animateLegacyCategories').on('change.animateLegacyCategories', syncAnimateCategories);
            }

            [pricePrimary, priceShadow].filter(Boolean).forEach(function (input) {
                $(input).off('input.animateLegacyPrice change.animateLegacyPrice').on('input.animateLegacyPrice change.animateLegacyPrice', function () {
                    syncAnimatePrice(input);
                });
            });

            if (customPriceRadio) {
                $(document)
                    .off('change.animateLegacyPriceToggle')
                    .on('change.animateLegacyPriceToggle', 'input[name="listing[field_6qzwdgqtsuhne0oqrogg]"], input[name="field_6qzwdgqtsuhne0oqrogg"]', toggleAnimatePriceField);
            }

            syncAnimatePrice(priceShadow && priceShadow.value !== '' ? priceShadow : pricePrimary);
            toggleAnimatePriceField();

            const form = categorySelect?.form || categoryHidden?.form || pricePrimary?.form || priceShadow?.form;
            if (form) {
                $(form).off('submit.animateLegacySync').on('submit.animateLegacySync', function () {
                    syncAnimateCategories();
                    syncAnimatePrice(priceShadow && priceShadow.value !== '' ? priceShadow : pricePrimary);
                });
            }
        }

        // Initialize file fields
        function initializeFileFields() {
            $('.file-field').each(function () {
                const href = $(this).attr('href');
                if (!href || href.trim() === '') {
                    $(this).hide();
                }
            });
        }

        // Run all fixes
        try {
            // Apply fixes with a slight delay to ensure DOM is ready
            setTimeout(() => {
                fixSelect2();
                fixRadioButtons();
                togglePriceField();
                fixAnimateLegacyForm();
                initializeFileFields();
            }, 100);

            // Re-apply fixes when DOM changes (for dynamic content)
            const observer = new MutationObserver((mutations) => {
                let shouldReapply = false;

                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1) { // Element node
                                if (node.matches && (
                                    node.matches('select, input[type="radio"], .w-radio') ||
                                    node.querySelector && node.querySelector('select, input[type="radio"], .w-radio')
                                )) {
                                    shouldReapply = true;
                                }
                            }
                        });
                    }
                });

                if (shouldReapply) {
                    setTimeout(() => {
                        fixSelect2();
                        fixRadioButtons();
                        fixAnimateLegacyForm();
                    }, 100);
                }
            });

            // Observe the form container
            const formContainer = document.querySelector('#wf-form-') ||
                document.querySelector('#myForm') ||
                document.querySelector('form');
            if (formContainer) {
                observer.observe(formContainer, {
                    childList: true,
                    subtree: true
                });
            }

        } catch (error) {
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            waitForDependencies(initializeFormElements);
        });
    } else {
        waitForDependencies(initializeFormElements);
    }

    // Also initialize on jQuery ready if available
    if (typeof jQuery !== 'undefined') {
        jQuery(() => {
            waitForDependencies(initializeFormElements);
        });
    }

    // Expose function globally for debugging
    window.reapplyFormFlowFixes = () => {
        waitForDependencies(initializeFormElements);
    };
})();
